<template>
    <v-container fluid>
        <v-toolbar extended class="elevation-1">
            <v-btn
                @click="fab = !fab"
                :color="fab_color"
                dark
                fab
                small
                class="mr-2"
                elevation="1"
            >
                <v-icon size="18" v-if="!fab">mdi-filter-variant</v-icon>
                <v-icon size="18" v-else>close</v-icon>
            </v-btn>
            <v-slide-x-transition>
                <div v-show="fab" style="position: fixed; margin-left: 50px">
                    <v-btn
                        @click.stop="filterOn('finish')"
                        :color="status.finish ? 'success' : '#999'"
                        rounded
                        small
                        dark
                        class="mx-1"
                    >
                        {{ $t("message.FinishButton") }}
                    </v-btn>
                    <v-btn
                        @click.stop="filterOn('didNotShow')"
                        :color="status.didNotShow ? 'black' : '#999'"
                        rounded
                        dark
                        small
                        class="mx-1"
                    >
                        {{ $t("message.DidNotShowButton") }}
                    </v-btn>
                </div>
            </v-slide-x-transition>

            <v-toolbar-title
                v-if="!fab && $vuetify.breakpoint.smAndUp"
                class="ml-2"
            >
                {{ $t("message.Registrations_Archive") }}
            </v-toolbar-title>

            <template v-slot:extension>
                <v-menu
                    ref="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            prepend-icon="event"
                            class="archive-picker"
                            v-model="fromFormatted"
                            readonly
                            v-on="on"
                            :loading="$store.getters.isArchiveDateFromDefault"
                        >
                            <template v-slot:progress>
                                <v-progress-linear
                                    v-if="
                                        $store.getters.isArchiveDateFromDefault
                                    "
                                    :value="100"
                                    color="success"
                                    absolute
                                    height="3"
                                >
                                </v-progress-linear>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="$store.state.RegistrationsArchive.archive.from"
                        no-title
                        scrollable
                    ></v-date-picker>
                </v-menu>
                <!-- :max="new Date().toISOString().substr(0, 10)" -->
                <v-menu
                    ref="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            prepend-icon="event"
                            class="archive-picker"
                            v-model="toFormatted"
                            readonly
                            v-on="on"
                            :loading="$store.getters.isArchiveDateToDefault"
                        >
                            <template v-slot:progress>
                                <v-progress-linear
                                    v-if="$store.getters.isArchiveDateToDefault"
                                    :value="100"
                                    color="success"
                                    absolute
                                    height="3"
                                >
                                </v-progress-linear>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="$store.state.RegistrationsArchive.archive.to"
                        no-title
                        scrollable
                    ></v-date-picker>
                </v-menu>
                <!-- :max="new Date().toISOString().substr(0, 10)" -->
                <v-tooltip
                    v-if="
                        !$store.getters.isArchiveDateFromDefault ||
                        !$store.getters.isArchiveDateToDefault
                    "
                    bottom
                >
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            @click="setDatesToDefault()"
                            v-on="tooltip"
                            icon
                            rounded
                            medium
                            class="ml-1 mb-4"
                            :loading="$store.getters.getLoading"
                        >
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </template>
                    <span> {{ $t("message.ResetToDefaultDates") }} </span>
                    <v-progress-linear
                        :value="100"
                        color="success"
                        absolute
                        height="5"
                    >
                    </v-progress-linear>
                </v-tooltip>
            </template>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-dialog
            @keydown.esc="close"
            v-model="dialog"
            max-width="800"
            scrollable
            persistent
            ref="dialog"
            :transition="
                $vuetify.breakpoint.smAndDown
                    ? 'slide-y-transition'
                    : 'scale-transition'
            "
            :fullscreen="$vuetify.breakpoint.smAndDown"
        >
            <v-card class="register-card">
                <v-card-title>
                    <span class="headline">{{
                        $t("message.Registrations_Archive")
                    }}</span>
                    <v-spacer></v-spacer>
                    <v-btn id="close-btn" rounded icon @click="close">
                        <v-icon medium>cancel</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <v-container>
                            <v-row justify="center" dense>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        filled
                                        dense
                                        disabled
                                        :value="truck.company_name"
                                        :label="formHeaders[0].text"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        filled
                                        dense
                                        disabled
                                        :value="truck.notification_email"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[1].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        :value="truck.reference"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[2].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        :label="formHeaders[3].text"
                                        :value="truck.contact"
                                    />
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        append-icon="event"
                                        :value="truck.arrival_date_from"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[4].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        append-icon="event"
                                        :value="truck.arrival_date_to"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[5].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        append-icon="access_time"
                                        :value="truck.arrival_time_from"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[6].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        append-icon="access_time"
                                        :value="truck.arrival_time_to"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[7].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        :label="formHeaders[8].text"
                                        :value="truck.driver"
                                    />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        :label="formHeaders[9].text"
                                        :value="truck.license_plate"
                                    />
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        :value="truck.type"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[10].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        :value="truck.transp_name"
                                    >
                                        <template v-slot:label>
                                            {{ formHeaders[11].text }}
                                            <strong style="color: red"
                                                >*</strong
                                            >
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field
                                        disabled
                                        outlined
                                        filled
                                        dense
                                        :label="formHeaders[12].text"
                                        :value="truck.dock"
                                    />
                                </v-col>

                                <v-col cols="12">
                                    <v-textarea
                                        disabled
                                        rows="2"
                                        auto-grow
                                        outlined
                                        filled
                                        dense
                                        :label="formHeaders[13].text"
                                        :value="truck.remarks_customer"
                                        >{{
                                            truck.remarks_customer
                                        }}</v-textarea
                                    >
                                </v-col>
                                <v-col cols="12">
                                    <v-textarea
                                        disabled
                                        rows="2"
                                        auto-grow
                                        v-if="
                                            $can('access', 'backOfficeRemarks')
                                        "
                                        :label="formHeaders[14].text"
                                        outlined
                                        filled
                                        dense
                                        :value="truck.remarks_backoffice"
                                        >{{
                                            truck.remarks_backoffice
                                        }}</v-textarea
                                    >
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        :value="truck.handling_charges"
                                        :items="getHandlingChargesEntries"
                                        :label="formHeaders[15].text"
                                        outlined
                                        dense
                                        filled
                                        disabled
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions></v-card-actions>
            </v-card>
        </v-dialog>
        <v-data-table
            :headers="tableHeaders"
            :loading="$store.getters.getLoading"
            :items="items"
            :search="$store.getters.getSearch"
            :lang="this.$i18n.locale"
            class="elevation-5"
            :items-per-page.sync="numItems"
            sort-by="intDate"
            height="calc(100vh - 220px - 48px - 40px)"
            fixed-header
            mobile-breakpoint="0"
            :footer-props="$store.getters.getFooterProps"
            :custom-filter="customSearch"
        >
            <template slot="item" slot-scope="props">
                <tr
                    :style="
                        $can('read', 'registrationsarchive')
                            ? 'cursor:pointer'
                            : ''
                    "
                    @click="
                        $can('read', 'registrationsarchive')
                            ? showInfo(props.item)
                            : ''
                    "
                    class="text-no-wrap"
                >
                    <td>
                        <v-btn
                            v-if="props.item.status == '1'"
                            class="body-1 font-weight-bold"
                            :ripple="false"
                            @click.stop
                            text
                            small
                            style="cursor: default"
                        >
                            <v-icon class="pr-2" color="success"
                                >check_circle</v-icon
                            >
                            {{ $t("message.FinishButton") }}
                        </v-btn>
                        <v-btn
                            v-else
                            class="body-1 font-weight-bold"
                            :ripple="false"
                            @click.stop
                            text
                            small
                            style="cursor: default"
                        >
                            <v-icon class="pr-2">report_problem</v-icon>
                            {{ $t("message.DidNotShowButton") }}
                        </v-btn>
                    </td>

                    <td>{{ showDates(props.item) }}</td>

                    <td>
                        {{ props.item.arrival_time_from }} -
                        {{ props.item.arrival_time_to }}
                    </td>

                    <td>{{ types[props.item.type / 5 - 1] }}</td>

                    <td v-if="$can('readCompanies', 'registrationsarchive')">
                        {{ props.item.company_name }}
                    </td>

                    <td>{{ props.item.transp_name }}</td>

                    <td>{{ props.item.reference }}</td>
                    <td>
                        <v-tooltip
                            bottom
                            v-if="
                                props.item.remarks_customer &&
                                props.item.remarks_customer.length > 25
                            "
                        >
                            <template v-slot:activator="{ on }">
                                <div v-on="on">
                                    {{
                                        props.item.remarks_customer.slice(
                                            0,
                                            20
                                        ) + "..."
                                    }}
                                </div>
                            </template>
                            <span>{{ props.item.remarks_customer }}</span>
                        </v-tooltip>
                        <div v-else>{{ props.item.remarks_customer }}</div>
                    </td>
                    <td>{{ props.item.handling_charges }}</td>
                    <td>
                        <v-tooltip
                            bottom
                            v-if="
                                props.item.remarks_backoffice &&
                                props.item.remarks_backoffice.length > 25
                            "
                        >
                            <template v-slot:activator="{ on }">
                                <div v-on="on">
                                    {{
                                        props.item.remarks_backoffice.slice(
                                            0,
                                            20
                                        ) + "..."
                                    }}
                                </div>
                            </template>
                            <span>{{ props.item.remarks_backoffice }}</span>
                        </v-tooltip>
                        <div v-else>{{ props.item.remarks_backoffice }}</div>
                    </td>
                    <td>{{ props.item.updated_at }}</td>

                    <td v-if="$can('undo', 'registrationsarchive')">
                        <v-btn small @click.stop="undo(props.item)">
                            <v-icon>undo</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:no-data>
                <v-alert
                    :value="true"
                    dense
                    class="my-3 text-capitalize body-1"
                    color="warning"
                    icon="warning"
                >
                    {{ $t("message.NoResults") }}
                    {{ $t("message.From") + " " + fromFormatted }}
                    {{ $t("message.To") + " " + toFormatted }}
                    {{
                        current_status
                            ? ' for "' + $t("message." + current_status) + '"'
                            : ""
                    }}
                </v-alert>
            </template>
            <template v-slot:no-results>
                <v-alert
                    slot="no-results"
                    dense
                    :value="true"
                    class="body-1 my-3"
                    color="error"
                    icon="warning"
                >
                    {{ $t("message.YourSearch") }} "{{
                        $store.getters.getSearch
                    }}"
                    {{ $t("message.NoResults") }}
                </v-alert>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { formatDate } from "../utils/dates";

export default {
    data: () => ({
        fromFormatted: null,
        toFormatted: null,
        fab: true,
        status: {
            finish: false,
            didNotShow: false,
        },
        dialog: false,
        editedIndex: -1,
        defaultTruck: {
            company: "",
            notification_email: "",
            contact: "",
            arrival_date_from: "",
            arrival_date_to: "",
            arrival_time_from: "",
            arrival_time_to: "",
            type: "",
            dock: "",
            reference: "",
            updated_at: "",
            transp_name: "",
            driver: "",
            handling_charges: "",
            license_plate: "",
            remarks_customer: "",
            remarks_backoffice: "",
        },
        truck: {
            company: "",
            notification_email: "",
            contact: "",
            arrival_date_from: "",
            arrival_date_to: "",
            arrival_time_from: "",
            arrival_time_to: "",
            type: "",
            dock: "",
            reference: "",
            updated_at: "",
            transp_name: "",
            driver: "",
            license_plate: "",
            handling_charges: "",
            remarks_customer: "",
            remarks_backoffice: "",
            registrationStatus: "",
        },
        companies: [],
        types: ["Load", "Unload", "Load & Unload"],
        numItems: 35,
    }),

    computed: {
        getHandlingChargesEntries() {
            let handlingCharges = [
                ...this.$store.getters.getHandlingChargesEntries,
            ];
            if (
                !handlingCharges.some(
                    item => item.value == this.truck.handling_charges
                )
            ) {
                handlingCharges.push({
                    text: this.truck.handling_charges,
                    value: this.truck.handling_charges,
                });
            }
            return handlingCharges;
        },
        current_status() {
            return Object.keys(this.status).find(
                type => this.status[type] === true
            );
        },
        fab_color() {
            return this.current_status
                ? this.determineColor(this.current_status)
                : "primary";
        },
        items() {
            return this.$store.getters.getArchive.filter(item => {
                const filters = !this.status.finish && !this.status.didNotShow;
                return (
                    this.status[item.status - 1 ? "didNotShow" : "finish"] ||
                    filters
                );
            });
        },
        determineColor() {
            return status => {
                switch (status) {
                    case "finish":
                        return "success";
                    case "didNotShow":
                        return "black";
                    default:
                        return "";
                }
            };
        },
        showDates() {
            return item => {
                if (item.arrival_date_from === item.arrival_date_to) {
                    return item.arrival_date_from;
                }
                return `${item.arrival_date_from} ${this.$t("message.To")} ${
                    item.arrival_date_to
                }`;
            };
        },
        tableHeaders() {
            return [
                {
                    text: this.$t("message.Status"),
                    value: "status",
                    sortable: true,
                },
                {
                    text: this.$t("message.Date"),
                    value: "intDate",
                    sortable: true,
                },
                {
                    text: this.$t("message.Time"),
                    value: "arrival_time_from",
                },
                {
                    text: this.$t("message.Type"),
                    value: "type",
                    sortable: true,
                },
                {
                    text: this.$t("message.Company"),
                    value: "company_name",
                    sortable: true,
                    hidden: !this.$can("readCompanies", "registrationsarchive"),
                },
                {
                    text: this.$t("message.Transporter"),
                    value: "transp_name",
                    sortable: true,
                },
                {
                    text: this.$t("message.Reference"),
                    value: "reference",
                    sortable: true,
                },
                {
                    text: this.$t("message.CustomerRemarks"),
                    value: "remarks_customer",
                    sortable: false,
                },
                {
                    text: this.$t("message.HandlingCharges"),
                    value: "handling_charges",
                    sortable: false,
                },
                {
                    text: this.$t("message.BackOfficeRemarks"),
                    value: "remarks_backoffice",
                    sortable: false,
                },
                {
                    text: this.$t("message.LastModified"),
                    value: "intUpdatedAt",
                    sortable: true,
                },
                {
                    text: this.$t("message.Actions"),
                    value: "undo",
                    sortable: false,
                    hidden: !this.$can("undo", "registrationsarchive"),
                },
            ].filter(title => !title.hidden);
        },
        formHeaders() {
            return [
                {
                    text: this.$t("message.Company"),
                    value: "company",
                },
                {
                    text: this.$t("message.Email"),
                    value: "email",
                },
                {
                    text: this.$t("message.Reference"),
                    value: "reference",
                },
                {
                    text: this.$t("message.ContactPerson"),
                    value: "contact",
                },
                {
                    text: this.$t("message.StartDate"),
                    value: "arrival_date_from",
                },
                {
                    text: this.$t("message.EndDate"),
                    value: "arrival_date_to",
                },
                {
                    text: this.$t("message.ArrivalTimeFrom"),
                    value: "arrival_time_from",
                },
                {
                    text: this.$t("message.ArrivalTimeTo"),
                    value: "arrival_time_to",
                },
                {
                    text: this.$t("message.NameDriver"),
                    value: "driver",
                },
                {
                    text: this.$t("message.LicensePlate"),
                    value: "license_plate",
                },
                {
                    text: this.$t("message.Type"),
                    value: "type",
                },
                {
                    text: this.$t("message.Transporter"),
                    value: "transp_name",
                },
                {
                    text: this.$t("message.Dock"),
                    value: "dock",
                },
                {
                    text: this.$t("message.CustomerRemarks"),
                    value: "customer_remarks",
                },
                {
                    text: this.$t("message.BackOfficeRemarks"),
                    value: "remarks_backoffice",
                },
                {
                    text: this.$t("message.HandlingCharges"),
                    value: "handling_charges",
                },
            ];
        },
    },
    mounted() {
        this.$store.dispatch("processArchive");
        this.initialize();
    },
    watch: {
        "$store.state.RegistrationsArchive.archive.from": async function (val) {
            if (
                this.$store.state.RegistrationsArchive.archive.from >
                this.$store.state.RegistrationsArchive.archive.to
            ) {
                this.$store.state.RegistrationsArchive.archive.to =
                    this.$store.state.RegistrationsArchive.archive.from;
            }
            this.fromFormatted = formatDate(val);
            await this.$store.dispatch("processArchive", {
                arrival_date_from: this.fromFormatted,
                arrival_date_to: this.toFormatted,
            });
            this.$refs.menu1.callDeactivate();
        },
        "$store.state.RegistrationsArchive.archive.to": async function (val) {
            if (
                this.$store.state.RegistrationsArchive.archive.to <
                this.$store.state.RegistrationsArchive.archive.from
            ) {
                this.$store.state.RegistrationsArchive.archive.from =
                    this.$store.state.RegistrationsArchive.archive.to;
            }
            this.toFormatted = formatDate(val);
            await this.$store.dispatch("processArchive", {
                arrival_date_from: this.fromFormatted,
                arrival_date_to: this.toFormatted,
            });
            this.$refs.menu2.callDeactivate();
        },
    },
    methods: {
        initialize() {
            this.fromFormatted = formatDate(
                this.$store.state.RegistrationsArchive.archive.from
            );
            this.toFormatted = formatDate(
                this.$store.state.RegistrationsArchive.archive.to
            );
        },
        customSearch(value, search, item) {
            return Object.values(item).some(
                v => v && v.toString().toLowerCase().includes(search)
            );
        },
        setDatesToDefault() {
            this.$store.state.RegistrationsArchive.archive.from =
                this.$store.state.RegistrationsArchive.archive.defaultFrom;
            this.$store.state.RegistrationsArchive.archive.to =
                this.$store.state.RegistrationsArchive.archive.defaultTo;
        },
        filterOn(type) {
            // Toggle chosen filter
            this.status[type] = !this.status[type];
            // Unmark all the rest of the filters
            for (const i in this.status) if (i !== type) this.status[i] = false;
        },
        showInfo(item) {
            this.truck = Object.assign({}, item);
            this.truck.type = this.types[this.truck.type / 5 - 1];
            this.dialog = true;
            this.setFocus();
        },
        undo(item) {
            this.$store.commit("popUp", {
                type: "undoArchive",
                id: item.truck_reg_id,
            });
        },
        setFocus() {
            setTimeout(() => {
                document.getElementById("close-btn").focus();
            }, 0);
        },
        close() {
            this.dialog = false;
        },
    },
};
</script>
